import { render, staticRenderFns } from "./DiscussMainItem.vue?vue&type=template&id=af0c1404&"
import script from "./DiscussMainItem.vue?vue&type=script&lang=js&"
export * from "./DiscussMainItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports